<div class="quest-list-container" *transloco="let t">

  <div class="quest-list-header">
    <button [matMenuTriggerFor]="questCreateChooser" class="primary-bar-btn">
      <svg class="pointer" viewBox="0 0 24 24" width="18" height="18">
        <use [attr.xlink:href]="'../../../../assets/icons/plus.svg#s'"></use>
      </svg>
      {{t('createNewQuest')}}
    </button>
    <mat-menu #questCreateChooser="matMenu">
      <a mat-menu-item routerLink="/quest-editor/new">
        <div class="display-flex-centered">
          {{t('regularQuest')}}
        </div>
      </a>
      @if (isUserSuperuser) {
        <a mat-menu-item routerLink="/quest-editor/adaptive/new">
          <div class="display-flex-centered">
            {{t('adaptiveQuest')}}
          </div>
        </a>
      }
    </mat-menu>
  </div>

  @if (loading()) {
    <div class="spinner-container">
      <mat-spinner></mat-spinner>
    </div>
  } @else {
    @if ((quests$ | async)?.length) {
      <app-quests-table-list
        [quests$]="quests$"
        [showMenu]="true"
        (select)="navigateToQuest($event)"
        (edit)="navigateToEditQuest($event)"
        (delete)="handleQuestDelete($event.id)"
        (shareCollaborator)="copyShareTokenToClipboard($event.id, 'collaborator')"
        (sharePlayer)="copyShareTokenToClipboard($event.id, 'player')"
        >
      </app-quests-table-list>
    } @else {
      <div class="no-quests-label-container">
        <h2>{{type === 'my' ? t('noMyQuests') : t('noSharedQuests')}}</h2>
        <h4>{{type === 'my' ? t('noMyQuestsSuggestion') : t('noSharedQuestsSuggestion')}}</h4>
      </div>
    }
  }

  @if (showDeleteConfirmation) {
    <app-modal [title]="t('areYouSureQ')" [footerButtons]="modalButtons" (closeEvent)="showDeleteConfirmation = false">
      <p class="text-color-soft">{{t('areYouSureToDeleteQuest')}}</p>
    </app-modal>
  }
</div>
